import type { FlatConfig } from 'domain/index';
import type { Metrics } from 'shared/state/types';
import { formatCapacityPb } from 'shared/lib/format';

export type StorageVariant = 'flash' | 'capacity';

/** Collapsed Section.Bar text. Pure so it can be asserted without rendering. */
export function storageSetSummary(variant: StorageVariant, config: FlatConfig, metrics: Metrics | null): string {
  const flash = variant === 'flash';
  const enabled = flash ? config.afaEnabled : config.hybridEnabled;
  if (!enabled) return 'Disabled';

  const nodes = flash ? config.afaNodeCount : config.hybridNodeCount;
  const scheme = flash ? config.afaEncodingScheme : config.hybridEncodingScheme;
  const effDisplay = flash ? metrics?.afaEffectiveCapacity : metrics?.hybridEffectiveCapacity;
  const useable = formatCapacityPb(effDisplay, config.isPBUnit);

  const media = flash
    ? `${config.afaVpodSsdCapacity} TB NVMe`
    : `${config.jbodSize} × ${config.hybridHddCapacity} TB HDD`;

  return `${nodes} ${flash ? 'F' : 'S'}-nodes · ${media} · ${scheme} · ${useable} useable`;
}
